import socketIo from "socket.io-client";
export const socket = (token) => {
  socketIo(process.env.REACT_APP_BASE_URL_DEV, {
    auth: { token },
  });
};
